import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { until } from 'lit/directives/until.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { EventsRequest } from '../../models/eventsRequest.js';
import { subscribe } from '../../common/reactiveX/rxElementDecorators.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import { EventConstant } from '../../common/eventConstants.js';
let FulfillmentResources = class FulfillmentResources extends RxElement {
    constructor() {
        super(...arguments);
        this.events = new EventsRequest();
        this._dragEvent = (e) => {
            const id = e.target.getAttribute('data-id');
            const title = e.target.getAttribute('data-title');
            const date = e.target.getAttribute('data-date');
            const slug = e.target.getAttribute('data-slug');
            const dateString = new Date(date).toLocaleDateString('en-us', {
                month: 'short',
                day: 'numeric',
            });
            const linkText = `${title} on ${dateString}`;
            e.dataTransfer.setData('text/html', `<a data-type="event" data-id="${id}" data-title="${title}" data-date="${date}" data-slug="${slug}" href="${process.env.HUB_DOMAIN}/?redir=/events/${id}" target="_blank">${linkText}</a>`);
        };
        this.getActiveEvents = (events) => {
            let activeEvents = [...events];
            activeEvents = activeEvents.filter((event) => (event.status_id === EventConstant.STATUS_ACTIVE ||
                (event.status_id === EventConstant.STATUS_FULL && event.has_waiting_list)) &&
                event.in_progress &&
                event.in_progress !== '1');
            return activeEvents;
        };
        this.getDuration = (event) => {
            var _a;
            if ((_a = event.timeslots) === null || _a === void 0 ? void 0 : _a.length)
                return undefined;
            if (event.type_slug === 'sessions')
                return undefined;
            return parseInt(event.duration, 10);
        };
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        until(this.fetchResources(), 'Loading...');
    }
    async fetchResources() {
        const requestUrl = `${process.env.API_URL}/blue/openrecommendations/topic/${this.topic}/subtopic/${this.subtopic}`;
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        const results = await fetch(new Request(requestUrl, {
            headers,
        }));
        if (results.ok || results.status === 200) {
            const json = await results.json();
            this.resources = { ...json[0] };
        }
        if (!results.ok || results.status !== 200) {
            this.resourcesError = `Error ${results.status}: ${results.statusText} was returned when requesting the resource at ${requestUrl}.`;
        }
        return null;
    }
    async fetchEvents() {
        try {
            const params = new URLSearchParams();
            params.append('show_extended', '1');
            params.append('show_vendors', '1');
            params.append('status', 'all');
            params.append('jwt', this.oasisToken);
            params.append('blue', '1');
            const requestUrl = `${process.env.HUB_DOMAIN}/rvapi/oasis/${this.hubSlug}/i/v1/reg382aff99c2cd31222f4e9d2e0dc7db6b/events?${params}`;
            const results = await fetch(new Request(requestUrl));
            const eventsErrorMessage = `Error ${results.status}: ${results.statusText} was returned when requesting the resource at ${requestUrl}.`;
            if (results.ok || results.status === 200) {
                this.events.status = 'FOUND';
                this.events.events = await results.json();
                this.requestUpdate();
            }
            else if (results.status === 404) {
                this.events.status = 'NOT_FOUND';
                this.events.errorMessage = eventsErrorMessage;
            }
            else {
                this.events.status = 'ERRORED';
                this.events.errorMessage = eventsErrorMessage;
            }
        }
        catch (error) {
            this.events.status = 'ERRORED';
            this.events.errorMessage = `Events failed to load with the error: ${error}`;
        }
    }
    render() {
        var _a, _b, _c, _d;
        const eventsData = (_b = (_a = this.events.events) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
        const activeEventsData = this.getActiveEvents(eventsData).slice(0, 3);
        if (typeof this.hubSlug !== 'undefined' &&
            typeof this.oasisToken !== 'undefined' &&
            this.events.status === 'INITIALIZING') {
            this.fetchEvents();
        }
        if (this.resourcesError) {
            return html `${this.resourcesError}`;
        }
        return html `<div class="suggestedResources">
			<div class="suggestedResources__header">
				<h2 class="suggestedResources__headerTitle">Suggested Resources</h2>
				<p class="suggestedResources__headerIntro">
					You can drag and drop the links to the body of the email
				</p>
			</div>
			<div class="suggestedResources__container">
				<div class="suggestedResources__resources">
					<h3 class="suggestedResources__resourcesTitle">Action Steps</h3>
					${!this.hasActions ||
            !this.resources ||
            Object.keys(this.resources).length === 0 ||
            this.resources.actions.length === 0
            ? html `<p class="suggestedResources__resourcesIntro">No Related Action Steps Found.</p>`
            : html `
                  <p class="suggestedResources__resourcesIntro">
                    Top recommended Action Steps.
                  </p>
                  ${this.resources.actions.length &&
                this.resources.actions.map(step => html `
													<a
														data-type="action"
														data-id="${step.actionId}"
														data-rank="${step.milestoneLevel}"
														data-title="${step.title}"
														data-slug="${step.slug}"
														class="suggestedResources__resource action"
														draggable="true"
														target="_blank"
														href="${process.env.HUB_DOMAIN}/?redir=/actionplan/${step.slug}"
														>${unsafeHTML(step.title)}</a
													>
												`)}
                </div>
              </div>
            </div>
          `}
				</div>
				<div class="suggestedResources__resources">
					<h3 class="suggestedResources__resourcesTitle">Resources</h3>
					${!this.hasArticles ||
            !this.resources ||
            Object.keys(this.resources).length === 0 ||
            ((_d = (_c = this.resources) === null || _c === void 0 ? void 0 : _c.articles) === null || _d === void 0 ? void 0 : _d.length) === 0
            ? html `<p class="suggestedResources__resourcesIntro">No Related Articles Found.</p>`
            : html `
                  <p class="suggestedResources__resourcesIntro">
                    Here are some related articles to the topic
                  </p>
                  ${this.resources.articles.length &&
                this.resources.articles.map(article => html `<a
													data-type="article"
													data-id="${article.contentId}"
													data-title="${article.title}"
													data-slug="${article.slug.replace('library/', '')}"
													class="suggestedResources__resource article"
													href="${process.env.HUB_DOMAIN}/?redir=/${article.slug}"
													target="_blank"
													>${article.title}</a
												>`)}
                </div>
              </div>
            </div>
          `}
				</div>
				<div class="suggestedResources__resources">
					<h3 class="suggestedResources__resourcesTitle">Events</h3>
					${this.events.errorMessage ? html `${this.events.errorMessage}` : null}
					${!this.events.events || !activeEventsData.length
            ? html `<p class="suggestedResources__resourcesIntro">No upcoming events found.</p>`
            : html `
								<p class="suggestedResources__resourcesIntro">
									See upcoming events for this client
								</p>
								${activeEventsData.length &&
                activeEventsData.map(event => {
                    const duration = this.getDuration(event);
                    return html `<div
										data-type="event"
										data-id="${event.id}"
										data-title="${event.title}"
										data-date="${new Date(event.date).toISOString()}"
										data-slug="${event.title.trim().replace(/ /g, '-').toLowerCase()}"
										class="event__card"
										target="_blank"
										draggable="true"
										@dragstart="${this._dragEvent}"
									>
										<div class="event__date">
											<span class="event__dateMonth"
												>${new Date(event.date).toLocaleString('default', { month: 'short' })}</span
											>
											${new Date(event.date).getUTCDate()}
										</div>
										<div class="event__details">
											<div class="event__title">${event.title}</div>
											<div class="event__meta">
												${duration
                        ? html `
															<div>
																<svg class="event__metaIcon">
																	<use
																		href="/static/icons.svg#stopwatch"
																		xlink:href="/static/icons.svg#stopwatch"
																	/>
																</svg>
																${duration} mins
															</div>
													  `
                        : null}
											</div>
										</div>
									</div>`;
                })}
						  `}
				</div>
			</div>
		</div>`;
    }
};
FulfillmentResources.styles = css `
		:host {
			flex: 0 0 343px;
		}
		.draggable {
			margin: 5px 0;
			padding: 10px;
			border: 1px solid #222;
			width: 100%;
			display: block;
			border-radius: 5px;
			box-sizing: border-box;
		}

		.suggestedResources__header {
			background: #007cac;
			border-radius: 15px 15px 0 0;
			padding: 15px 21px 25px;
			color: #fff;
		}
		.suggestedResources__headerTitle {
			margin: 0 0 2px;
			padding: 0;
			font-size: 18px;
			font-weight: 700;
		}
		.suggestedResources__headerIntro {
			margin: 0;
			padding: 0;
			font-size: 10px;
			font-weight: 400;
		}

		.suggestedResources__container {
			background: #fff;
			border-radius: 15px;
			box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.16);
			margin-top: -15px;
			padding: 18px 23px;
		}

		.suggestedResources__resources {
			border-bottom: 1px solid #efefef;
			padding: 15px 0 5px;
		}
		.suggestedResources__resources:first-child {
			padding-top: 0;
		}
		.suggestedResources__resources:last-child {
			border-bottom: 0;
		}
		.suggestedResources__resourcesTitle {
			font-size: 16px;
			font-weight: 700;
			color: #073853;
			padding: 0;
			margin: 0 0 2px;
		}
		.suggestedResources__resourcesIntro {
			font-size: 9px;
			font-weight: 400;
			color: #383838;
			margin: 0 0 12px;
			padding: 0;
		}

		.suggestedResources__resource {
			text-decoration: none;
			color: #007cab;
			font-size: 11px;
			font-weight: 500;
			display: block;
			padding: 0 0 10px;
			margin: 0 0 2px;
			line-height: 1.4;
		}

		.event__card {
			display: flex;
			flex-direction: row;
			align-items: center;
			border-bottom: 1px solid #f7f7fa;
			padding: 15px 0;
		}
		.event__card:last-child {
			border-bottom: 0;
		}
		.event__date {
			background: #007cab24;
			min-width: 45px;
			min-height: 45px;
			margin-right: 10px;
			border-radius: 8px;
			font-size: 17px;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			flex-direction: column;
			font-weight: 700;
			color: #007cab;
		}
		.event__dateMonth {
			font-size: 12px;
			display: block;
			margin-bottom: -2px;
		}
		.event__title {
			font-weight: 500;
			font-size: 14px;
			color: #333;
		}
		.event__meta {
			color: #9d9d9d;
			font-size: 12px;
			font-weight: 300;
			margin-top: 5px;
		}
		.event__metaIcon {
			width: 14px;
			height: 14px;
			margin: -2px 0 2px 0;
			vertical-align: middle;
		}
	`;
__decorate([
    property()
], FulfillmentResources.prototype, "topic", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "subtopic", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "hasActions", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "hasArticles", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "events", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "resources", void 0);
__decorate([
    state()
], FulfillmentResources.prototype, "resourcesError", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "oasisToken", void 0);
__decorate([
    property()
], FulfillmentResources.prototype, "hubSlug", void 0);
__decorate([
    subscribe(),
    state()
], FulfillmentResources.prototype, "blueUser", void 0);
FulfillmentResources = __decorate([
    customElement('fulfillment-resources')
], FulfillmentResources);
export { FulfillmentResources };
//# sourceMappingURL=resources.js.map